
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { uiStore } from "@/store/store";
import { saveToWordPressWithErrorsLoggedToUiStore } from "@/lib/wordpress/save";
import { keyboardShortcuts } from "@/lib/keyboard-shortcuts/keyboard-shortcuts";
import { KEYBOARD_SHORTCUTS } from "@/lib/keyboard-shortcuts/global-shortcuts";
import StandardButton from "@/components/UI/StandardButton.vue";
import {
  removeChangesNotSavedWarning,
  warnIfExitingWithUnsavedChanges
} from "@/util/warn-unsaved-changes";
import { breakdanceUndo } from "@/lib/undo/undo";

@Component({
  components: {
    StandardButton
  }
})
export default class Save extends Vue {
  saveInProgress = false;

  get unsavedChangesPresent() {
    return uiStore.unsavedChangesPresent;
  }

  async save() {
    document.dispatchEvent(new Event("breakdanceSaveButtonClicked"));

    this.saveInProgress = true;

    await saveToWordPressWithErrorsLoggedToUiStore();

    this.saveInProgress = false;
  }

  warnIfUnsavedFunction!: (e: Event) => void;

  unsubscribe: null | (() => void) = null;

  mounted() {
    keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_S);
    keyboardShortcuts.register(KEYBOARD_SHORTCUTS.CMD_S, this.save);

    this.unsubscribe = this.$store.subscribe(mutationPayload => {
      if (!breakdanceUndo.shouldMutationBeIgnored(mutationPayload)) {
        uiStore.setUnsavedChangesPresent(true);
      }
    });

    this.warnIfUnsavedFunction = warnIfExitingWithUnsavedChanges(
      () => uiStore.unsavedChangesPresent
    );
  }

  beforeDestroy() {
    keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_S);
    this.unsubscribe && this.unsubscribe();
    removeChangesNotSavedWarning(this.warnIfUnsavedFunction);
  }
}
